import {LAYER_SUBTYPE} from "@frontend/components/modules/layouts-page/modals/layout-preview/constants";

/**
 * @type FieldMapper
 */
export const multiLineTextMapper = ({
  templateSettings,
  field,
}) => {
  return {
    subType: LAYER_SUBTYPE.TEXT,
    text: templateSettings[field.element_id],
    angle: parseFloat(templateSettings[`${field.element_id}_angle`]),
    font: templateSettings[`${field.element_id}_font`],
    fontSize: parseInt(templateSettings[`${field.element_id}_fontsize`]),
    width: parseFloat(templateSettings[`${field.element_id}_width`]),
    height: parseFloat(templateSettings[`${field.element_id}_height`]),
    color: templateSettings[`${field.element_id}_color`]
  }
}
